// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"checkbox-3mtaI","aggre":"aggre-3Jep0","formComment":"formComment-3eb3O"};